export default "__VITE_ASSET__iUiPhQBE__"